import { render } from "./RetailerHeader.vue?vue&type=template&id=1b9d8cd8"
import script from "./RetailerHeader.vue?vue&type=script&lang=js"
export * from "./RetailerHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__